const campaigns = [
    {
        name: "General Mazda Intent",
        keywords: [
            "+mazda +discount",
            "+mazda +for +sale",
            "+mazda +incentive",
            "+mazda +offer",
            "+mazda +sale +event",
            "+mazda +msrp"
        ],
        negative_keyword_lists: []
    },
    {
        name: "General Mazda Lease",
        keywords: ["+mazda +lease +deal", "+mazda +lease +offer"],
        negative_keyword_lists: []
    },
    {
        name: "All Models Static",
        keywords: [
            `"buy mazda cx-30"`,
            `"buy mazda cx-5"`,
            `"buy mazda cx-50"`,
            `"buy mazda cx-9"`,
            `"buy mazda cx-90 phev"`,
            `"buy mazda cx-90"`,
            `"buy mazda mx-30"`,
            `"buy mazda mx-5 miata"`,
            `"buy mazda"`,
            `"buy mazda3"`,
            `"closest mazda dealership"`,
            `"how much is mazda cx-30"`,
            `"how much is mazda cx-5"`,
            `"how much is mazda cx-50"`,
            `"how much is mazda cx-9"`,
            `"how much is mazda cx-90 phev"`,
            `"how much is mazda cx-90"`,
            `"how much is mazda mx-30"`,
            `"how much is mazda mx-5 miata"`,
            `"how much is mazda3"`,
            `"local mazda dealerships"`,
            `"mazda around me"`,
            `"mazda build and price"`,
            `"mazda car dealership"`,
            `"mazda car lease"`,
            `"mazda cars for sale"`,
            `"mazda cx-30 cars for sale"`,
            `"mazda cx-30 cost"`,
            `"mazda cx-30 deal"`,
            `"mazda cx-30 dealer near me"`,
            `"mazda cx-30 dealer"`,
            `"mazda cx-30 dealership"`,
            `"mazda cx-30 finance"`,
            `"mazda cx-30 for sale near me"`,
            `"mazda cx-30 for sale"`,
            `"mazda cx-30 incentive"`,
            `"mazda cx-30 lease deal"`,
            `"mazda cx-30 lease offer"`,
            `"mazda cx-30 lease price"`,
            `"mazda cx-30 lease specials"`,
            `"mazda cx-30 lease"`,
            `"mazda cx-30 msrp"`,
            `"mazda cx-30 near me"`,
            `"mazda cx-30 new car price"`,
            `"mazda cx-30 payment"`,
            `"mazda cx-30 price"`,
            `"mazda cx-30 pricing"`,
            `"mazda cx-30 sale"`,
            `"mazda cx-5 cars for sale"`,
            `"mazda cx-5 cost"`,
            `"mazda cx-5 deal"`,
            `"mazda cx-5 dealer near me"`,
            `"mazda cx-5 dealer"`,
            `"mazda cx-5 dealership"`,
            `"mazda cx-5 finance"`,
            `"mazda cx-5 for sale near me"`,
            `"mazda cx-5 for sale"`,
            `"mazda cx-5 incentive"`,
            `"mazda cx-5 lease deal"`,
            `"mazda cx-5 lease offer"`,
            `"mazda cx-5 lease price"`,
            `"mazda cx-5 lease specials"`,
            `"mazda cx-5 lease"`,
            `"mazda cx-5 msrp"`,
            `"mazda cx-5 near me"`,
            `"mazda cx-5 new car price"`,
            `"mazda cx-5 payment"`,
            `"mazda cx-5 price"`,
            `"mazda cx-5 pricing"`,
            `"mazda cx-5 sale"`,
            `"mazda cx-50 cars for sale"`,
            `"mazda cx-50 cost"`,
            `"mazda cx-50 deal"`,
            `"mazda cx-50 dealer near me"`,
            `"mazda cx-50 dealer"`,
            `"mazda cx-50 dealership"`,
            `"mazda cx-50 finance"`,
            `"mazda cx-50 for sale near me"`,
            `"mazda cx-50 for sale"`,
            `"mazda cx-50 incentive"`,
            `"mazda cx-50 lease deal"`,
            `"mazda cx-50 lease offer"`,
            `"mazda cx-50 lease price"`,
            `"mazda cx-50 lease specials"`,
            `"mazda cx-50 lease"`,
            `"mazda cx-50 msrp"`,
            `"mazda cx-50 near me"`,
            `"mazda cx-50 new car price"`,
            `"mazda cx-50 payment"`,
            `"mazda cx-50 price"`,
            `"mazda cx-50 pricing"`,
            `"mazda cx-50 sale"`,
            `"mazda cx-9 cars for sale"`,
            `"mazda cx-9 cost"`,
            `"mazda cx-9 deal"`,
            `"mazda cx-9 dealer near me"`,
            `"mazda cx-9 dealer"`,
            `"mazda cx-9 dealership"`,
            `"mazda cx-9 finance"`,
            `"mazda cx-9 for sale near me"`,
            `"mazda cx-9 for sale"`,
            `"mazda cx-9 incentive"`,
            `"mazda cx-9 lease deal"`,
            `"mazda cx-9 lease offer"`,
            `"mazda cx-9 lease price"`,
            `"mazda cx-9 lease specials"`,
            `"mazda cx-9 lease"`,
            `"mazda cx-9 msrp"`,
            `"mazda cx-9 near me"`,
            `"mazda cx-9 new car price"`,
            `"mazda cx-9 payment"`,
            `"mazda cx-9 price"`,
            `"mazda cx-9 pricing"`,
            `"mazda cx-9 sale"`,
            `"mazda cx-90 cars for sale"`,
            `"mazda cx-90 cost"`,
            `"mazda cx-90 deal"`,
            `"mazda cx-90 dealer near me"`,
            `"mazda cx-90 dealer"`,
            `"mazda cx-90 dealership"`,
            `"mazda cx-90 finance"`,
            `"mazda cx-90 for sale near me"`,
            `"mazda cx-90 for sale"`,
            `"mazda cx-90 incentive"`,
            `"mazda cx-90 lease deal"`,
            `"mazda cx-90 lease offer"`,
            `"mazda cx-90 lease price"`,
            `"mazda cx-90 lease specials"`,
            `"mazda cx-90 lease"`,
            `"mazda cx-90 msrp"`,
            `"mazda cx-90 near me"`,
            `"mazda cx-90 new car price"`,
            `"mazda cx-90 payment"`,
            `"mazda cx-90 phev cars for sale"`,
            `"mazda cx-90 phev cost"`,
            `"mazda cx-90 phev deal"`,
            `"mazda cx-90 phev dealer near me"`,
            `"mazda cx-90 phev dealer"`,
            `"mazda cx-90 phev dealership"`,
            `"mazda cx-90 phev finance"`,
            `"mazda cx-90 phev for sale near me"`,
            `"mazda cx-90 phev for sale"`,
            `"mazda cx-90 phev incentive"`,
            `"mazda cx-90 phev lease deal"`,
            `"mazda cx-90 phev lease offer"`,
            `"mazda cx-90 phev lease price"`,
            `"mazda cx-90 phev lease specials"`,
            `"mazda cx-90 phev lease"`,
            `"mazda cx-90 phev msrp"`,
            `"mazda cx-90 phev near me"`,
            `"mazda cx-90 phev new car price"`,
            `"mazda cx-90 phev payment"`,
            `"mazda cx-90 phev price"`,
            `"mazda cx-90 phev pricing"`,
            `"mazda cx-90 phev sale"`,
            `"mazda cx-90 price"`,
            `"mazda cx-90 pricing"`,
            `"mazda cx-90 sale"`,
            `"mazda dealer nearest me"`,
            `"mazda dealership hours"`,
            `"mazda dealership near me"`,
            `"mazda dealership"`,
            `"mazda deals"`,
            `"mazda finance deals"`,
            `"mazda finance"`,
            `"mazda for sale near me"`,
            `"mazda for sale"`,
            `"mazda incentives"`,
            `"mazda lease deals"`,
            `"mazda lease offers"`,
            `"mazda lease specials"`,
            `"mazda leasing"`,
            `"mazda msrp"`,
            `"mazda mx-30 cars for sale"`,
            `"mazda mx-30 cost"`,
            `"mazda mx-30 deal"`,
            `"mazda mx-30 dealer near me"`,
            `"mazda mx-30 dealer"`,
            `"mazda mx-30 dealership"`,
            `"mazda mx-30 finance"`,
            `"mazda mx-30 for sale near me"`,
            `"mazda mx-30 for sale"`,
            `"mazda mx-30 incentive"`,
            `"mazda mx-30 lease deal"`,
            `"mazda mx-30 lease offer"`,
            `"mazda mx-30 lease price"`,
            `"mazda mx-30 lease specials"`,
            `"mazda mx-30 lease"`,
            `"mazda mx-30 msrp"`,
            `"mazda mx-30 near me"`,
            `"mazda mx-30 new car price"`,
            `"mazda mx-30 payment"`,
            `"mazda mx-30 price"`,
            `"mazda mx-30 pricing"`,
            `"mazda mx-30 sale"`,
            `"mazda mx-5 miata cars for sale"`,
            `"mazda mx-5 miata cost"`,
            `"mazda mx-5 miata deal"`,
            `"mazda mx-5 miata dealer near me"`,
            `"mazda mx-5 miata dealer"`,
            `"mazda mx-5 miata dealership"`,
            `"mazda mx-5 miata finance"`,
            `"mazda mx-5 miata for sale near me"`,
            `"mazda mx-5 miata for sale"`,
            `"mazda mx-5 miata incentive"`,
            `"mazda mx-5 miata lease deal"`,
            `"mazda mx-5 miata lease offer"`,
            `"mazda mx-5 miata lease price"`,
            `"mazda mx-5 miata lease specials"`,
            `"mazda mx-5 miata lease"`,
            `"mazda mx-5 miata msrp"`,
            `"mazda mx-5 miata near me"`,
            `"mazda mx-5 miata new car price"`,
            `"mazda mx-5 miata payment"`,
            `"mazda mx-5 miata price"`,
            `"mazda mx-5 miata pricing"`,
            `"mazda mx-5 miata sale"`,
            `"mazda near me"`,
            `"mazda nearby"`,
            `"mazda offers"`,
            `"mazda payment"`,
            `"mazda price"`,
            `"mazda showroom near me"`,
            `"mazda special offers"`,
            `"mazda specials"`,
            `"mazda3 cars for sale"`,
            `"mazda3 cost"`,
            `"mazda3 deal"`,
            `"mazda3 dealer near me"`,
            `"mazda3 dealer"`,
            `"mazda3 dealership"`,
            `"mazda3 finance"`,
            `"mazda3 for sale near me"`,
            `"mazda3 for sale"`,
            `"mazda3 incentive"`,
            `"mazda3 lease deal"`,
            `"mazda3 lease offer"`,
            `"mazda3 lease price"`,
            `"mazda3 lease specials"`,
            `"mazda3 lease"`,
            `"mazda3 msrp"`,
            `"mazda3 near me"`,
            `"mazda3 new car price"`,
            `"mazda3 payment"`,
            `"mazda3 price"`,
            `"mazda3 pricing"`,
            `"mazda3 sale"`,
            `"nearest mazda dealer"`,
            `"new mazda cx-30 for sale"`,
            `"new mazda cx-30 price"`,
            `"new mazda cx-5 for sale"`,
            `"new mazda cx-5 price"`,
            `"new mazda cx-50 for sale"`,
            `"new mazda cx-50 price"`,
            `"new mazda cx-9 for sale"`,
            `"new mazda cx-9 price"`,
            `"new mazda cx-90 for sale"`,
            `"new mazda cx-90 phev for sale"`,
            `"new mazda cx-90 phev price"`,
            `"new mazda cx-90 price"`,
            `"new mazda for sale"`,
            `"new mazda mx-30 for sale"`,
            `"new mazda mx-30 price"`,
            `"new mazda mx-5 miata for sale"`,
            `"new mazda mx-5 miata price"`,
            `"new mazda3 price"`,
            `[buy CX-30]`,
            `[buy CX30]`,
            `[buy mazda cx-30]`,
            `[buy mazda cx-5]`,
            `[buy mazda cx-50]`,
            `[buy mazda cx-9]`,
            `[buy mazda cx-90 phev]`,
            `[buy mazda cx-90]`,
            `[buy mazda mx-30]`,
            `[buy mazda mx-5 miata]`,
            `[buy mazda]`,
            `[buy mazda3]`,
            `[buy Mazda6]`,
            `[buy new CX-30]`,
            `[buy new CX30]`,
            `[buy new Mazda3]`,
            `[buy new Mazda6]`,
            `[closest mazda dealership]`,
            `[CX-30 deal]`,
            `[CX-30 deals]`,
            `[CX-30 incentive]`,
            `[CX-30 incentives]`,
            `[CX-30 lease]`,
            `[CX-30 MSRP]`,
            `[CX-30 price]`,
            `[CX-30 quote]`,
            `[CX-30 quotes]`,
            `[CX-30 rebate]`,
            `[CX-30 rebates]`,
            `[CX-30 sale]`,
            `[CX-30 sales]`,
            `[CX-30 special]`,
            `[CX-30 specials]`,
            `[CX-30 test drive]`,
            `[CX-30 test drives]`,
            `[CX30 deal]`,
            `[CX30 deals]`,
            `[CX30 incentive]`,
            `[CX30 incentives]`,
            `[CX30 lease]`,
            `[CX30 MSRP]`,
            `[CX30 price]`,
            `[CX30 quote]`,
            `[CX30 quotes]`,
            `[CX30 rebate]`,
            `[CX30 rebates]`,
            `[CX30 sale]`,
            `[CX30 sales]`,
            `[CX30 special]`,
            `[CX30 specials]`,
            `[CX30 test drive]`,
            `[CX30 test drives]`,
            `[finance CX-30]`,
            `[finance CX30]`,
            `[finance Mazda3]`,
            `[finance Mazda6]`,
            `[finance new CX-30]`,
            `[finance new CX30]`,
            `[finance new Mazda3]`,
            `[finance new Mazda6]`,
            `[how much is mazda cx-30]`,
            `[how much is mazda cx-5]`,
            `[how much is mazda cx-50]`,
            `[how much is mazda cx-9]`,
            `[how much is mazda cx-90 phev]`,
            `[how much is mazda cx-90]`,
            `[how much is mazda mx-30]`,
            `[how much is mazda mx-5 miata]`,
            `[how much is mazda3]`,
            `[local mazda dealerships]`,
            `[mazda around me]`,
            `[mazda build and price]`,
            `[mazda car dealership]`,
            `[mazda car lease]`,
            `[mazda cars for sale]`,
            `[mazda cx-30 cars for sale]`,
            `[mazda cx-30 cost]`,
            `[mazda cx-30 deal]`,
            `[mazda cx-30 dealer near me]`,
            `[mazda cx-30 dealer]`,
            `[mazda cx-30 dealership]`,
            `[mazda cx-30 finance]`,
            `[mazda cx-30 for sale near me]`,
            `[mazda cx-30 for sale]`,
            `[mazda cx-30 incentive]`,
            `[mazda cx-30 lease deal]`,
            `[mazda cx-30 lease offer]`,
            `[mazda cx-30 lease price]`,
            `[mazda cx-30 lease specials]`,
            `[mazda cx-30 lease]`,
            `[mazda cx-30 msrp]`,
            `[mazda cx-30 near me]`,
            `[mazda cx-30 new car price]`,
            `[mazda cx-30 payment]`,
            `[mazda cx-30 price]`,
            `[mazda cx-30 pricing]`,
            `[mazda cx-30 sale]`,
            `[mazda cx-5 cars for sale]`,
            `[mazda cx-5 cost]`,
            `[mazda cx-5 deal]`,
            `[mazda cx-5 dealer near me]`,
            `[mazda cx-5 dealer]`,
            `[mazda cx-5 dealership]`,
            `[mazda cx-5 finance]`,
            `[mazda cx-5 for sale near me]`,
            `[mazda cx-5 for sale]`,
            `[mazda cx-5 incentive]`,
            `[mazda cx-5 lease deal]`,
            `[mazda cx-5 lease offer]`,
            `[mazda cx-5 lease price]`,
            `[mazda cx-5 lease specials]`,
            `[mazda cx-5 lease]`,
            `[mazda cx-5 msrp]`,
            `[mazda cx-5 near me]`,
            `[mazda cx-5 new car price]`,
            `[mazda cx-5 payment]`,
            `[mazda cx-5 price]`,
            `[mazda cx-5 pricing]`,
            `[mazda cx-5 sale]`,
            `[mazda cx-50 cars for sale]`,
            `[mazda cx-50 cost]`,
            `[mazda cx-50 deal]`,
            `[mazda cx-50 dealer near me]`,
            `[mazda cx-50 dealer]`,
            `[mazda cx-50 dealership]`,
            `[mazda cx-50 finance]`,
            `[mazda cx-50 for sale near me]`,
            `[mazda cx-50 for sale]`,
            `[mazda cx-50 incentive]`,
            `[mazda cx-50 lease deal]`,
            `[mazda cx-50 lease offer]`,
            `[mazda cx-50 lease price]`,
            `[mazda cx-50 lease specials]`,
            `[mazda cx-50 lease]`,
            `[mazda cx-50 msrp]`,
            `[mazda cx-50 near me]`,
            `[mazda cx-50 new car price]`,
            `[mazda cx-50 payment]`,
            `[mazda cx-50 price]`,
            `[mazda cx-50 pricing]`,
            `[mazda cx-50 sale]`,
            `[mazda cx-9 cars for sale]`,
            `[mazda cx-9 cost]`,
            `[mazda cx-9 deal]`,
            `[mazda cx-9 dealer near me]`,
            `[mazda cx-9 dealer]`,
            `[mazda cx-9 dealership]`,
            `[mazda cx-9 finance]`,
            `[mazda cx-9 for sale near me]`,
            `[mazda cx-9 for sale]`,
            `[mazda cx-9 incentive]`,
            `[mazda cx-9 lease deal]`,
            `[mazda cx-9 lease offer]`,
            `[mazda cx-9 lease price]`,
            `[mazda cx-9 lease specials]`,
            `[mazda cx-9 lease]`,
            `[mazda cx-9 msrp]`,
            `[mazda cx-9 near me]`,
            `[mazda cx-9 new car price]`,
            `[mazda cx-9 payment]`,
            `[mazda cx-9 price]`,
            `[mazda cx-9 pricing]`,
            `[mazda cx-9 sale]`,
            `[mazda cx-90 cars for sale]`,
            `[mazda cx-90 cost]`,
            `[mazda cx-90 deal]`,
            `[mazda cx-90 dealer near me]`,
            `[mazda cx-90 dealer]`,
            `[mazda cx-90 dealership]`,
            `[mazda cx-90 finance]`,
            `[mazda cx-90 for sale near me]`,
            `[mazda cx-90 for sale]`,
            `[mazda cx-90 incentive]`,
            `[mazda cx-90 lease deal]`,
            `[mazda cx-90 lease offer]`,
            `[mazda cx-90 lease price]`,
            `[mazda cx-90 lease specials]`,
            `[mazda cx-90 lease]`,
            `[mazda cx-90 msrp]`,
            `[mazda cx-90 near me]`,
            `[mazda cx-90 new car price]`,
            `[mazda cx-90 payment]`,
            `[mazda cx-90 phev cars for sale]`,
            `[mazda cx-90 phev cost]`,
            `[mazda cx-90 phev deal]`,
            `[mazda cx-90 phev dealer near me]`,
            `[mazda cx-90 phev dealer]`,
            `[mazda cx-90 phev dealership]`,
            `[mazda cx-90 phev finance]`,
            `[mazda cx-90 phev for sale near me]`,
            `[mazda cx-90 phev for sale]`,
            `[mazda cx-90 phev incentive]`,
            `[mazda cx-90 phev lease deal]`,
            `[mazda cx-90 phev lease offer]`,
            `[mazda cx-90 phev lease price]`,
            `[mazda cx-90 phev lease specials]`,
            `[mazda cx-90 phev lease]`,
            `[mazda cx-90 phev msrp]`,
            `[mazda cx-90 phev near me]`,
            `[mazda cx-90 phev new car price]`,
            `[mazda cx-90 phev payment]`,
            `[mazda cx-90 phev price]`,
            `[mazda cx-90 phev pricing]`,
            `[mazda cx-90 phev sale]`,
            `[mazda cx-90 price]`,
            `[mazda cx-90 pricing]`,
            `[mazda cx-90 sale]`,
            `[mazda cx3 for sale]`,
            `[mazda cx5 for sale]`,
            `[mazda cx9 for sale]`,
            `[mazda dealer nearest me]`,
            `[mazda dealership hours]`,
            `[mazda dealership near me]`,
            `[mazda dealership]`,
            `[mazda deals]`,
            `[mazda finance deals]`,
            `[mazda finance]`,
            `[mazda for sale near me]`,
            `[mazda for sale]`,
            `[mazda incentives]`,
            `[mazda lease deals]`,
            `[mazda lease offers]`,
            `[mazda lease specials]`,
            `[mazda leasing]`,
            `[mazda miata for sale]`,
            `[mazda msrp]`,
            `[mazda mx-30 cars for sale]`,
            `[mazda mx-30 cost]`,
            `[mazda mx-30 deal]`,
            `[mazda mx-30 dealer near me]`,
            `[mazda mx-30 dealer]`,
            `[mazda mx-30 dealership]`,
            `[mazda mx-30 finance]`,
            `[mazda mx-30 for sale near me]`,
            `[mazda mx-30 for sale]`,
            `[mazda mx-30 incentive]`,
            `[mazda mx-30 lease deal]`,
            `[mazda mx-30 lease offer]`,
            `[mazda mx-30 lease price]`,
            `[mazda mx-30 lease specials]`,
            `[mazda mx-30 lease]`,
            `[mazda mx-30 msrp]`,
            `[mazda mx-30 near me]`,
            `[mazda mx-30 new car price]`,
            `[mazda mx-30 payment]`,
            `[mazda mx-30 price]`,
            `[mazda mx-30 pricing]`,
            `[mazda mx-30 sale]`,
            `[mazda mx-5 miata cars for sale]`,
            `[mazda mx-5 miata cost]`,
            `[mazda mx-5 miata deal]`,
            `[mazda mx-5 miata dealer near me]`,
            `[mazda mx-5 miata dealer]`,
            `[mazda mx-5 miata dealership]`,
            `[mazda mx-5 miata finance]`,
            `[mazda mx-5 miata for sale near me]`,
            `[mazda mx-5 miata for sale]`,
            `[mazda mx-5 miata incentive]`,
            `[mazda mx-5 miata lease deal]`,
            `[mazda mx-5 miata lease offer]`,
            `[mazda mx-5 miata lease price]`,
            `[mazda mx-5 miata lease specials]`,
            `[mazda mx-5 miata lease]`,
            `[mazda mx-5 miata msrp]`,
            `[mazda mx-5 miata near me]`,
            `[mazda mx-5 miata new car price]`,
            `[mazda mx-5 miata payment]`,
            `[mazda mx-5 miata price]`,
            `[mazda mx-5 miata pricing]`,
            `[mazda mx-5 miata sale]`,
            `[mazda mx5 deal]`,
            `[mazda mx5 deals]`,
            `[mazda mx5 finance]`,
            `[mazda mx5 for sale]`,
            `[mazda mx5 incentive]`,
            `[mazda mx5 incentives]`,
            `[mazda mx5 lease deal]`,
            `[mazda mx5 lease deals]`,
            `[mazda mx5 lease offer]`,
            `[mazda mx5 lease offers]`,
            `[mazda mx5 lease]`,
            `[mazda mx5 leases]`,
            `[mazda mx5 msrp]`,
            `[mazda mx5 payment]`,
            `[mazda mx5 price]`,
            `[mazda near me]`,
            `[mazda nearby]`,
            `[mazda offers]`,
            `[mazda payment]`,
            `[mazda price]`,
            `[mazda showroom near me]`,
            `[mazda special offers]`,
            `[mazda specials]`,
            `[mazda3 cars for sale]`,
            `[mazda3 cost]`,
            `[mazda3 deal]`,
            `[mazda3 dealer near me]`,
            `[mazda3 dealer]`,
            `[mazda3 dealership]`,
            `[Mazda3 deals]`,
            `[mazda3 finance]`,
            `[mazda3 for sale near me]`,
            `[mazda3 for sale]`,
            `[mazda3 incentive]`,
            `[Mazda3 incentives]`,
            `[mazda3 lease deal]`,
            `[mazda3 lease offer]`,
            `[mazda3 lease price]`,
            `[mazda3 lease specials]`,
            `[mazda3 lease]`,
            `[mazda3 msrp]`,
            `[mazda3 near me]`,
            `[mazda3 new car price]`,
            `[mazda3 payment]`,
            `[mazda3 price]`,
            `[mazda3 pricing]`,
            `[Mazda3 quote]`,
            `[Mazda3 quotes]`,
            `[Mazda3 rebate]`,
            `[Mazda3 rebates]`,
            `[mazda3 sale]`,
            `[Mazda3 sales]`,
            `[Mazda3 special]`,
            `[Mazda3 specials]`,
            `[Mazda3 test drive]`,
            `[Mazda3 test drives]`,
            `[Mazda6 deal]`,
            `[Mazda6 deals]`,
            `[Mazda6 incentive]`,
            `[Mazda6 incentives]`,
            `[Mazda6 lease]`,
            `[Mazda6 MSRP]`,
            `[Mazda6 price]`,
            `[Mazda6 quote]`,
            `[Mazda6 quotes]`,
            `[Mazda6 rebate]`,
            `[Mazda6 rebates]`,
            `[Mazda6 sale]`,
            `[Mazda6 sales]`,
            `[Mazda6 special]`,
            `[Mazda6 specials]`,
            `[Mazda6 test drive]`,
            `[Mazda6 test drives]`,
            `[nearest mazda dealer]`,
            `[new CX-30 deal]`,
            `[new CX-30 deals]`,
            `[new CX-30 incentive]`,
            `[new CX-30 incentives]`,
            `[new CX-30 lease]`,
            `[new CX-30 MSRP]`,
            `[new CX-30 price]`,
            `[new CX-30 quote]`,
            `[new CX-30 quotes]`,
            `[new CX-30 rebate]`,
            `[new CX-30 rebates]`,
            `[new CX-30 sale]`,
            `[new CX-30 sales]`,
            `[new CX-30 special]`,
            `[new CX-30 specials]`,
            `[new CX-30 test drive]`,
            `[new CX-30 test drives]`,
            `[new CX30 deal]`,
            `[new CX30 deals]`,
            `[new CX30 incentive]`,
            `[new CX30 incentives]`,
            `[new CX30 lease]`,
            `[new CX30 MSRP]`,
            `[new CX30 price]`,
            `[new CX30 quote]`,
            `[new CX30 quotes]`,
            `[new CX30 rebate]`,
            `[new CX30 rebates]`,
            `[new CX30 sale]`,
            `[new CX30 sales]`,
            `[new CX30 special]`,
            `[new CX30 specials]`,
            `[new CX30 test drive]`,
            `[new CX30 test drives]`,
            `[new mazda cx-30 for sale]`,
            `[new mazda cx-30 price]`,
            `[new mazda cx-5 for sale]`,
            `[new mazda cx-5 price]`,
            `[new mazda cx-50 for sale]`,
            `[new mazda cx-50 price]`,
            `[new mazda cx-9 for sale]`,
            `[new mazda cx-9 price]`,
            `[new mazda cx-90 for sale]`,
            `[new mazda cx-90 phev for sale]`,
            `[new mazda cx-90 phev price]`,
            `[new mazda cx-90 price]`,
            `[new mazda for sale]`,
            `[new mazda mx-30 for sale]`,
            `[new mazda mx-30 price]`,
            `[new mazda mx-5 miata for sale]`,
            `[new mazda mx-5 miata price]`,
            `[new Mazda3 deal]`,
            `[new Mazda3 deals]`,
            `[new Mazda3 incentive]`,
            `[new Mazda3 incentives]`,
            `[new Mazda3 lease]`,
            `[new Mazda3 MSRP]`,
            `[new mazda3 price]`,
            `[new Mazda3 quote]`,
            `[new Mazda3 quotes]`,
            `[new Mazda3 rebate]`,
            `[new Mazda3 rebates]`,
            `[new Mazda3 sale]`,
            `[new Mazda3 sales]`,
            `[new Mazda3 special]`,
            `[new Mazda3 specials]`,
            `[new Mazda3 test drive]`,
            `[new Mazda3 test drives]`,
            `[new Mazda6 deal]`,
            `[new Mazda6 deals]`,
            `[new Mazda6 incentive]`,
            `[new Mazda6 incentives]`,
            `[new Mazda6 lease]`,
            `[new Mazda6 MSRP]`,
            `[new Mazda6 price]`,
            `[new Mazda6 quote]`,
            `[new Mazda6 quotes]`,
            `[new Mazda6 rebate]`,
            `[new Mazda6 rebates]`,
            `[new Mazda6 sale]`,
            `[new Mazda6 sales]`,
            `[new Mazda6 special]`,
            `[new Mazda6 specials]`,
            `[new Mazda6 test drive]`,
            `[new Mazda6 test drives]`,
            `[purchase CX-30]`,
            `[purchase CX30]`,
            `[purchase Mazda3]`,
            `[purchase Mazda6]`,
            `[purchase new CX-30]`,
            `[purchase new CX30]`,
            `[purchase new Mazda3]`,
            `[purchase new Mazda6]`,
            `"buy CX-30"`,
            `"buy CX30"`,
            `"buy Mazda6"`,
            `"buy new CX-30"`,
            `"buy new CX30"`,
            `"buy new Mazda3"`,
            `"buy new Mazda6"`,
            `"CX-30 deal"`,
            `"CX-30 deals"`,
            `"CX-30 incentive"`,
            `"CX-30 incentives"`,
            `"CX-30 lease"`,
            `"CX-30 MSRP"`,
            `"CX-30 price"`,
            `"CX-30 quote"`,
            `"CX-30 quotes"`,
            `"CX-30 rebate"`,
            `"CX-30 rebates"`,
            `"CX-30 sale"`,
            `"CX-30 sales"`,
            `"CX-30 special"`,
            `"CX-30 specials"`,
            `"CX-30 test drive"`,
            `"CX-30 test drives"`,
            `"CX30 deal"`,
            `"CX30 deals"`,
            `"CX30 incentive"`,
            `"CX30 incentives"`,
            `"CX30 lease"`,
            `"CX30 MSRP"`,
            `"CX30 price"`,
            `"CX30 quote"`,
            `"CX30 quotes"`,
            `"CX30 rebate"`,
            `"CX30 rebates"`,
            `"CX30 sale"`,
            `"CX30 sales"`,
            `"CX30 special"`,
            `"CX30 specials"`,
            `"CX30 test drive"`,
            `"CX30 test drives"`,
            `"finance CX-30"`,
            `"finance CX30"`,
            `"finance Mazda3"`,
            `"finance Mazda6"`,
            `"finance new CX-30"`,
            `"finance new CX30"`,
            `"finance new Mazda3"`,
            `"finance new Mazda6"`,
            `"how much is mazda mx5"`,
            `"mazda cx3 for sale"`,
            `"mazda cx5 for sale"`,
            `"mazda cx9 for sale"`,
            `"mazda miata for sale"`,
            `"mazda mx5 deal"`,
            `"mazda mx5 deals"`,
            `"mazda mx5 finance"`,
            `"mazda mx5 for sale"`,
            `"mazda mx5 incentive"`,
            `"mazda mx5 incentives"`,
            `"mazda mx5 lease"`,
            `"mazda mx5 lease deal"`,
            `"mazda mx5 lease deals"`,
            `"mazda mx5 lease offer"`,
            `"mazda mx5 lease offers"`,
            `"mazda mx5 leases"`,
            `"mazda mx5 msrp"`,
            `"mazda mx5 payment"`,
            `"mazda mx5 price"`,
            `"Mazda3 deals"`,
            `"Mazda3 incentives"`,
            `"Mazda3 quote"`,
            `"Mazda3 quotes"`,
            `"Mazda3 rebate"`,
            `"Mazda3 rebates"`,
            `"Mazda3 sales"`,
            `"Mazda3 special"`,
            `"Mazda3 specials"`,
            `"Mazda3 test drive"`,
            `"Mazda3 test drives"`,
            `"Mazda6 deal"`,
            `"Mazda6 deals"`,
            `"Mazda6 incentive"`,
            `"Mazda6 incentives"`,
            `"Mazda6 lease"`,
            `"Mazda6 MSRP"`,
            `"Mazda6 price"`,
            `"Mazda6 quote"`,
            `"Mazda6 quotes"`,
            `"Mazda6 rebate"`,
            `"Mazda6 rebates"`,
            `"Mazda6 sale"`,
            `"Mazda6 sales"`,
            `"Mazda6 special"`,
            `"Mazda6 specials"`,
            `"Mazda6 test drive"`,
            `"Mazda6 test drives"`,
            `"new CX-30 deal"`,
            `"new CX-30 deals"`,
            `"new CX-30 incentive"`,
            `"new CX-30 incentives"`,
            `"new CX-30 lease"`,
            `"new CX-30 MSRP"`,
            `"new CX-30 price"`,
            `"new CX-30 quote"`,
            `"new CX-30 quotes"`,
            `"new CX-30 rebate"`,
            `"new CX-30 rebates"`,
            `"new CX-30 sale"`,
            `"new CX-30 sales"`,
            `"new CX-30 special"`,
            `"new CX-30 specials"`,
            `"new CX-30 test drive"`,
            `"new CX-30 test drives"`,
            `"new CX30 deal"`,
            `"new CX30 deals"`,
            `"new CX30 incentive"`,
            `"new CX30 incentives"`,
            `"new CX30 lease"`,
            `"new CX30 MSRP"`,
            `"new CX30 price"`,
            `"new CX30 quote"`,
            `"new CX30 quotes"`,
            `"new CX30 rebate"`,
            `"new CX30 rebates"`,
            `"new CX30 sale"`,
            `"new CX30 sales"`,
            `"new CX30 special"`,
            `"new CX30 specials"`,
            `"new CX30 test drive"`,
            `"new CX30 test drives"`,
            `"new Mazda3 deal"`,
            `"new Mazda3 deals"`,
            `"new Mazda3 incentive"`,
            `"new Mazda3 incentives"`,
            `"new Mazda3 lease"`,
            `"new Mazda3 MSRP"`,
            `"new Mazda3 quote"`,
            `"new Mazda3 quotes"`,
            `"new Mazda3 rebate"`,
            `"new Mazda3 rebates"`,
            `"new Mazda3 sale"`,
            `"new Mazda3 sales"`,
            `"new Mazda3 special"`,
            `"new Mazda3 specials"`,
            `"new Mazda3 test drive"`,
            `"new Mazda3 test drives"`,
            `"new Mazda6 deal"`,
            `"new Mazda6 deals"`,
            `"new Mazda6 incentive"`,
            `"new Mazda6 incentives"`,
            `"new Mazda6 lease"`,
            `"new Mazda6 MSRP"`,
            `"new Mazda6 price"`,
            `"new Mazda6 quote"`,
            `"new Mazda6 quotes"`,
            `"new Mazda6 rebate"`,
            `"new Mazda6 rebates"`,
            `"new Mazda6 sale"`,
            `"new Mazda6 sales"`,
            `"new Mazda6 special"`,
            `"new Mazda6 specials"`,
            `"new Mazda6 test drive"`,
            `"new Mazda6 test drives"`,
            `"purchase CX-30"`,
            `"purchase CX30"`,
            `"purchase Mazda3"`,
            `"purchase Mazda6"`,
            `"purchase new CX-30"`,
            `"purchase new CX30"`,
            `"purchase new Mazda3"`,
            `"purchase new Mazda6"`,
            `[mazda CX90 new car price]`,
            `[mazda CX90 payment]`,
            `[mazda CX90 cars for sale]`,
            `[mazda CX90 deal]`,
            `[mazda CX90 incentive]`,
            `[mazda CX90 lease offer]`,
            `[mazda CX90 dealer near me]`,
            `[mazda CX90 lease]`,
            `[mazda CX90 cost]`,
            `[buy mazda CX90]`,
            `[mazda CX90 finance]`,
            `[how much is mazda CX90]`,
            `[mazda CX90 price]`,
            `[mazda CX90 pricing]`,
            `[new mazda CX90 price]`,
            `[mazda CX90 msrp]`,
            `[mazda CX90 lease deal]`,
            `[mazda CX90 for sale]`,
            `[mazda CX90 sale]`,
            `[new mazda CX90 for sale]`,
            `[mazda CX90 lease price]`,
            `[mazda CX90 lease specials]`,
            `[mazda CX90 dealer]`,
            `[mazda CX90 dealership]`,
            `[mazda CX90 for sale near me]`,
            `[mazda CX90 near me]`,
            `"mazda CX90 new car price"`,
            `"mazda CX90 payment"`,
            `"mazda CX90 cars for sale"`,
            `"mazda CX90 deal"`,
            `"mazda CX90 incentive"`,
            `"mazda CX90 lease offer"`,
            `"mazda CX90 dealer near me"`,
            `"mazda CX90 lease"`,
            `"mazda CX90 cost"`,
            `"buy mazda CX90"`,
            `"mazda CX90 finance"`,
            `"how much is mazda CX90"`,
            `"mazda CX90 price"`,
            `"mazda CX90 pricing"`,
            `"new mazda CX90 price"`,
            `"mazda CX90 msrp"`,
            `"mazda CX90 lease deal"`,
            `"mazda CX90 for sale"`,
            `"mazda CX90 sale"`,
            `"new mazda CX90 for sale"`,
            `"mazda CX90 lease price"`,
            `"mazda CX90 lease specials"`,
            `"mazda CX90 dealer"`,
            `"mazda CX90 dealership"`,
            `"mazda CX90 for sale near me"`,
            `"mazda CX90 near me"`
        ],
        negative_keyword_lists: []
    }
];

export default campaigns;
